import TargetType from './target/TargetType';
import TargetExtends from './target/TargetExtends';
import Name from './target/Name';
import ExtName from './target/ExtName';
import Org from './evalscore/Org';
import SelectInput from './evalscore/SelectInput';
import SubItem from './subresult/SubItem';
import DataGridMul from './evalscore/DataGridMul'
import ResultDataGrid from './subresult/DataGridMul'

export default {
    TargetType,
    TargetExtends,
    Name,
    ExtName,
    Org,
    SelectInput,
    SubItem,
    DataGridMul,
    ResultDataGrid
}